import { render, staticRenderFns } from "./ajustesDeInventarioDeProducto.vue?vue&type=template&id=50a7270f"
import script from "./ajustesDeInventarioDeProducto.vue?vue&type=script&lang=js"
export * from "./ajustesDeInventarioDeProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports